// ModalFooter.tsx
import React, { useContext } from 'react';
import { ModalVariantContext } from '../../ModalContext';

interface ModalFooterProps {
  children: React.ReactNode;
}

const ModalFooter: React.FC<ModalFooterProps> = ({ children }) => {
  const variant = useContext(ModalVariantContext);

  const variantClasses = {
    neutral: {
      border: 'border-indigo-700',
      text: 'text-white',
      background: 'bg-indigo-900',
    },
    warning: {
      border: 'border-cherry-400',
      text: 'text-indigo-1000',
    },
  };

  return (
    <div
      className={`flex justify-center items-center gap-x-2 py-3 px-4 border-t max-sm:sticky max-sm:bottom-0 ${variantClasses[variant].border} ${variantClasses[variant].text} ${variantClasses[variant].background}`}
    >
      {children}
    </div>
  );
};

export default ModalFooter;
